// src/models/userModel.js - Apartment Management System Frontend
import api from '../services/api';




// Get all users
export const getAllUsers = async (filters = {}) => {
    try {
        const response = await api.get('/users', { params: filters });
        return response.data;
    } catch (error) {
        throw error.response?.data || { success: false, message: 'Error fetching users' };
    }
};

// Create new user
export const createUser = async (userData) => {
    try {
        const response = await api.post('/users', userData);
        return response.data;
    } catch (error) {
        throw error.response?.data || { success: false, message: 'Error creating user' };
    }
};

// Get user by id
export const getUser = async (id) => {
    try {
        const response = await api.get(`/users/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || { success: false, message: 'Error fetching user' };
    }
};

// Update user
export const updateUser = async (id, userData) => {
    try {
        const response = await api.put(`/users/${id}`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data || { success: false, message: 'Error updating user' };
    }
};

// Get user profile
export const getUserProfile = async () => {
    try {
        const response = await api.get('/users/profile');
        return response.data;
    } catch (error) {
        throw error.response?.data || { success: false, message: 'Error fetching profile' };
    }
};

// Update user profile
export const updateUserProfile = async (userData) => {
    try {
        const response = await api.put('/users/profile', userData);
        return response.data;
    } catch (error) {
        throw error.response?.data || { success: false, message: 'Error updating profile' };
    }
};

// Change password
export const changePassword = async (currentPassword, newPassword) => {
    try {
        const response = await api.put('/users/change-password', { currentPassword, newPassword });
        return response.data;
    } catch (error) {
        throw error.response?.data || { success: false, message: 'Error changing password' };
    }
};

// Deactivate user
export const deactivateUser = async (id) => {
    try {
        const response = await api.put(`/users/${id}/deactivate`, {});
        return response.data;
    } catch (error) {
        throw error.response?.data || { success: false, message: 'Error deactivating user' };
    }
};

// Activate user
export const activateUser = async (id) => {
    try {
        const response = await api.put(`/users/${id}/activate`, {});
        return response.data;
    } catch (error) {
        throw error.response?.data || { success: false, message: 'Error activating user' };
    }
};

// Delete user
export const deleteUser = async (id) => {
    try {
        const response = await api.delete(`/users/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || { success: false, message: 'Error deleting user' };
    }
};

// Reset user password (Admin only)
export const resetUserPassword = async (id, newPassword) => {
    try {
        const response = await api.put(`/users/${id}/reset-password`, { newPassword });
        return response.data;
    } catch (error) {
        throw error.response?.data || { success: false, message: 'Error resetting password' };
    }
};

// Get user activity logs
export const getUserActivity = async (id, options = {}) => {
    try {
        const response = await api.get(`/users/${id}/activity`, { params: options });
        return response.data;
    } catch (error) {
        throw error.response?.data || { success: false, message: 'Error fetching user activity' };
    }
};

// Get user sessions
export const getUserSessions = async (id) => {
    try {
        const response = await api.get(`/users/${id}/sessions`);
        return response.data;
    } catch (error) {
        throw error.response?.data || { success: false, message: 'Error fetching user sessions' };
    }
};

// Validate user data
export const validateUserData = (userData) => {
    const errors = {};

    if (!userData.username?.trim()) {
        errors.username = 'Username is required';
    }

    if (!userData.email?.trim()) {
        errors.email = 'Email is required';
    } else {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(userData.email)) {
            errors.email = 'Please provide a valid email address';
        }
    }

    if (userData.password !== undefined && userData.password?.length < 6) {
        errors.password = 'Password must be at least 6 characters';
    }

    if (!userData.firstName?.trim()) {
        errors.firstName = 'First name is required';
    }

    if (!userData.lastName?.trim()) {
        errors.lastName = 'Last name is required';
    }

    return {
        isValid: Object.keys(errors).length === 0,
        errors
    };
};

// User roles for filters and forms
export const USER_ROLES = [
    { value: 'admin', label: 'Administrator' },
    { value: 'front_desk', label: 'Front Desk' },
    { value: 'accountant', label: 'Accountant' },
    { value: 'sales', label: 'Sales' }
];

// Default export (for components that import the entire module)
export default {
    getAllUsers,
    createUser,
    getUser,
    updateUser,
    getUserProfile,
    updateUserProfile,
    changePassword,
    deactivateUser,
    activateUser,
    deleteUser,
    resetUserPassword,
    getUserActivity,
    getUserSessions,
    validateUserData,
    USER_ROLES
};